import styled from '@emotion/styled';

export const Root = styled.div(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(1),
  flexDirection: 'column',
  gap: theme.spacing(2),
  maxWidth: '354px',
  margin: '0 auto',
  color: theme.colors.neutrals.grey1,
  a: {
    color: theme.colors.neutrals.grey1,
    marginRight: theme.spacing(1),
  },
  button: {
    marginTop: theme.spacing(1),
  },
}));
